export default __webpack_public_path__ + "static/media/wa.3e84f64a.svg";